module.exports = __webpack_public_path__ + "img/production-power-house.b052c661.jpg";